<template>
	<AppDialog v-model="isOpen">
		<div class="tw-rounded-lg tw-p-4" style="width: 600px">
			<div class="tw-pb-4">
				<div class="tw-text-lg tw-font-semibold">
					{{ $t('integrations.woocommerce-api-keys') }}
				</div>
				<div class="tw-text-gray-600">
					{{ $t('integrations.how-to-find-woocommerce-api-keys') }}
				</div>
			</div>

			<ol
				class="tw-flex tw-flex-col tw-gap-4 tw-px-4"
				type="1"
				start="1"
				style="list-style: decimal"
			>
				<li class="tw-border-b tw-border-b-gray-300 tw-pb-4">
					{{ $t('integrations.woocommerce-keys-step-open-settings') }}
				</li>
				<li class="tw-border-b tw-border-b-gray-300 tw-pb-4">
					{{ $t('integrations.woocommerce-keys-step-add-key') }}
				</li>
				<!-- Read/Write is required, not optional: Linker pushes stock, prices and
				     order statuses back to the store, and registers its own webhooks. -->
				<li class="tw-border-b tw-border-b-gray-300 tw-pb-4">
					{{ $t('integrations.woocommerce-keys-step-permissions') }}
				</li>
				<li class="tw-border-b tw-border-b-gray-300 tw-pb-4">
					{{ $t('integrations.woocommerce-keys-step-generate') }}
				</li>
				<!-- WooCommerce shows the secret once only; a seller who closes the page
				     has to delete the key and make a new one. -->
				<li>
					<div class="tw-font-medium tw-text-gray-800">
						{{ $t('integrations.woocommerce-keys-step-copy-once') }}
					</div>
				</li>
			</ol>

			<div class="tw-mt-4 tw-flex tw-items-center tw-justify-between">
				<a
					href="https://woocommerce.github.io/woocommerce-rest-api-docs/#rest-api-keys"
					target="_blank"
					class="tw-text-blue-500 tw-underline hover:tw-underline"
				>
					{{ $t('integrations.view-woocommerce-documentation') }}
				</a>
				<AppButton :label="$t('close')" variant="gray" secondary @click="isOpen = false" />
			</div>
		</div>
	</AppDialog>
</template>

<script setup>
import AppDialog from '@/v2/components/dialog.vue';
import { ref } from 'vue';

const isOpen = ref(false);

const open = () => {
	isOpen.value = true;
};

defineExpose({
	open,
});
</script>

<style lang="scss" scoped></style>
